export { contextColors as contextColorsDark } from './dark/colors';
export { contextColors } from './light/colors';
